// Adelphi University's undergraduate majors (#2746). Read on 2026-10-01 from
// Adelphi's official Majors and Programs list (adelphi.edu/programs), filtered
// to undergraduate programs school by school: every bachelor's line kept
// (BA, BS, BFA, BBA, BSW as the list writes them); minors, certificates, the
// AA in Liberal Arts and graduate programs left out. The 2026-27 University
// Bulletin (catalog.adelphi.edu) refused automated reads on the day, so the
// programs list is the source. A program the list files under more than one
// school (Health Sciences, Neuroscience, Art and Design Education, Music
// Education, Ethics and Public Policy, Information Systems, Healthcare
// Administration) appears once, under the first school here. Left out as
// entry paths, not majors: Business: Undeclared Major, the Business 3-Year
// Track, the Accelerated Nursing BS for students who already hold a degree,
// and Business Clusters for Non-Majors. "Online" marks the online
// degree-completion programs.
const majors = {
    "slug": "adelphi-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program on Adelphi's official Majors and Programs list, grouped by the school that offers it, with the degree it leads to. Minors, certificates, associate degrees and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Adelphi University, Majors and Programs (undergraduate, by school)",
                "url": "https://www.adelphi.edu/programs/"
            },
            "majors": [
                {
                    "name": "African, Black and Caribbean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Art",
                    "degree": "BA, BFA"
                },
                {
                    "name": "Art and Design Education",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA, BS"
                },
                {
                    "name": "Communications",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Ethics and Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Languages and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Latinx Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Music",
                    "degree": "BS"
                },
                {
                    "name": "Music Education",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "Gordon F. Derner School of Psychology",
            "source": {
                "label": "Adelphi University, Majors and Programs (undergraduate, by school)",
                "url": "https://www.adelphi.edu/programs/"
            },
            "majors": [
                {
                    "name": "Psychology",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Robert B. Willumstad School of Business",
            "source": {
                "label": "Adelphi University, Majors and Programs (undergraduate, by school)",
                "url": "https://www.adelphi.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics with STEM-Designation",
                    "degree": "BS"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Healthcare Administration",
                    "degree": "BS",
                    "note": "Online"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Ruth S. Ammon College of Education and Health Sciences",
            "source": {
                "label": "Adelphi University, Majors and Programs (undergraduate, by school)",
                "url": "https://www.adelphi.edu/programs/"
            },
            "majors": [
                {
                    "name": "Communication Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Physical Activity Studies",
                    "degree": "BS"
                },
                {
                    "name": "Physical Education",
                    "degree": "BS"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Nursing and Public Health",
            "source": {
                "label": "Adelphi University, Majors and Programs (undergraduate, by school)",
                "url": "https://www.adelphi.edu/programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Social Work",
            "source": {
                "label": "Adelphi University, Majors and Programs (undergraduate, by school)",
                "url": "https://www.adelphi.edu/programs/"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        },
        {
            "name": "College of Professional and Continuing Studies",
            "source": {
                "label": "Adelphi University, Majors and Programs (undergraduate, by school)",
                "url": "https://www.adelphi.edu/programs/"
            },
            "majors": [
                {
                    "name": "Business",
                    "degree": "BS",
                    "note": "Online"
                },
                {
                    "name": "Emergency Services",
                    "degree": "BS",
                    "note": "Online"
                },
                {
                    "name": "Emergency Services Administration",
                    "degree": "BS",
                    "note": "Online"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BA",
                    "note": "Online"
                },
                {
                    "name": "Natural Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Social Science",
                    "degree": "BA",
                    "note": "Online"
                }
            ]
        }
    ]
};

export default majors;
